import React, { memo, useState, useEffect } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { Spinner } from 'baseui/spinner'
import { Menu, Transition } from '@headlessui/react'
import { reactLocalStorage } from 'reactjs-localstorage'
import Classnames from 'classnames'

import { useRouter } from 'next/router'

import {
  RiShareFill,
  RiAddLine,
  RiMenuFill,
  RiShieldUserLine,
  RiDownloadLine,
  RiEyeLine,
  RiCheckboxCircleLine,
} from 'react-icons/ri'
import {
  useRecoilValue,
  useRecoilCallback,
  useRecoilTransactionObserver_UNSTABLE,
} from 'recoil'
import { contentIds, content, content_block } from '@/store/template/content'
import {
  publicIsLoggedIn,
  currentTemplateID,
  autoSavingStatus,
} from '@/store/onepager/onepager'

import useAutoSaveNotify from '@/utils/autosave-check'

import autoSave from '@/store/template/autosave'
import axios from 'axios'
import Cookies from 'js-cookie'
import _ from 'lodash'
import PublicHelloBar from '@/components/onepager/PublicHelloBar'

function DebugObserver({
  collection,
  isOnepagerForm,
  onepager,
  shouldRedirect,
  reloadSaveHistory,
}) {
  const autoSaveState = useRecoilTransactionObserver_UNSTABLE(
    ({ snapshot, previousSnapshot }) => {
      console.log('publicnav autoSaveState')
      // check if logged in
      const isLoggedIn = snapshot.getLoadable(publicIsLoggedIn).contents
      const getCurrentTemplateId =
        snapshot.getLoadable(currentTemplateID).contents

      // build CURRENT contentsDB and contentBlocksDB
      const contents = snapshot.getLoadable(contentIds).contents

      const contentsDB = []
      _.forEach(contents, function (contentID, index) {
        const contentAtom = snapshot.getLoadable(content(contentID)).contents
        contentsDB.push({ id: contentID, atom: contentAtom })
        // console.log('contentAtom', contentAtom)
      })
      const contentBlocksDB = []
      _.forEach(contentsDB, function (contentItem, index) {
        if (contentItem.atom.blocks) {
          _.forEach(contentItem.atom.blocks, function (contentBlockID, index) {
            const contentBlockAtom = snapshot.getLoadable(
              content_block(contentBlockID)
            ).contents
            // console.log('contentBlockAtom', contentBlockAtom)
            contentBlocksDB.push({ id: contentBlockID, atom: contentBlockAtom })
          })
        }
      })

      // console.log(contentsDB)
      // console.log(contentBlocksDB)

      // check if autoSave is true dont save, only if false
      const isSaving = snapshot.getLoadable(autoSavingStatus).contents
      const isSavingPrevious =
        previousSnapshot.getLoadable(autoSavingStatus).contents

      if (isSaving) {
        // don't trigger again - already saving
        if (onepager?.redirect_url && shouldRedirect) {
          setTimeout(() => {
            window.open(onepager.redirect_url, '_parent')
          }, 1000)
        }
      } else if (isSavingPrevious) {
        // don't trigger again - it was just saved - just switch to false
        reloadSaveHistory()
      } else {
        // isSaving is false, and isSavingPrevious is also false

        autoSave(
          isLoggedIn,
          getCurrentTemplateId,
          contentsDB,
          contentBlocksDB,
          isOnepagerForm
        )
      }
    }
  )
  return null
}

function PublicNav({
  collection,
  onepager,
  openSideBar,
  openSignUp,
  openShareModal,
  signUpBar,
  isOnepagerForm,
  hasSubmittedForm,
  shouldRedirect,
  isWizardLayout,
  reloadSaveHistory,
}) {
  const contents = useRecoilValue(contentIds)
  const [helloBar, setHelloBar] = useState(collection.header_cta_link)
  // const [isSaving, setSaving] = useState(false)
  const isSaving = useRecoilValue(autoSavingStatus)
  // const [isSaving] = useAutoSaveNotify()
  const router = useRouter()

  const checkIsLoggedIn = useRecoilValue(publicIsLoggedIn)
  // check if collection is already saved to account
  const [isSavedCollection, setSavedCollection] = useState(true)
  const [isSavedOnepager, setSavedOnepager] = useState(true)
  const [isSharedContent, setSharedContent] = useState(false)
  const [getUserEmail, setUserEmail] = useState('')
  // const [hasSubmittedForm, setSubmittedForm] = useState(false)

  // check if user saved this to account
  useEffect(async () => {
    if (checkIsLoggedIn) {
      // Trigger Save To Account
      const checkIfSaved = await axios.post('/api/save-to-account/check', {
        email: Cookies.get('wl-email'),
        templateId: findGetParameter('i'),
      })
      // false is not found
      setSavedOnepager(checkIfSaved.data.saved)
    }

    // check if share content
    if (findGetParameter('shareId')) {
      setSharedContent(true)
    }

    // if (Cookies.get('wl-email')) {
    //   setUserEmail(Cookies.get('wl-email'))
    // } else if (reactLocalStorage.get('wl-email', true)) {
    //   setUserEmail(reactLocalStorage.get('wl-email', true))
    // }
    setUserEmail(Cookies.get('wl-email'))
  }, [])

  useEffect(async () => {
    setUserEmail(Cookies.get('wl-email'))

    // segment.io identity for signup
    if (checkIsLoggedIn) {
      // analytics.identify({ email: Cookies.get('wl-email').toLowerCase() })
    }

    if (Cookies.get('submission-email')) {
      // setSubmittedForm(true)
    }
  }, [checkIsLoggedIn])

  function findGetParameter(parameterName) {
    var result = null,
      tmp = []
    location.search
      .substr(1)
      .split('&')
      .forEach(function (item) {
        tmp = item.split('=')
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
      })

    if (parameterName == 'i') {
      // check if it its a [url] page
      if (result) {
        return result
      } else {
        let getURL = router.query.url
        getURL = getURL.split('-')
        getURL = getURL.pop()
        return getURL
      }
    } else {
      // shareID or something else
      return result
    }
  }

  const saveContentState = useRecoilCallback(({ snapshot }) => () => {
    // build content json
    const contentsDB = []

    _.forEach(contents, function (contentID, index) {
      const contentAtom = snapshot.getLoadable(content(contentID)).contents
      contentsDB.push({ id: contentID, atom: contentAtom })
    })

    // build contentBlocks json
    const contentBlocksDB = []

    _.forEach(contentsDB, function (contentItem, index) {
      // check if content has .blocks array
      if (contentItem.atom.blocks) {
        // loop through each block, get by ID, and store in contentBlocksDB
        _.forEach(contentItem.atom.blocks, function (contentBlockID, index) {
          const contentBlockAtom = snapshot.getLoadable(
            content_block(contentBlockID)
          ).contents
          contentBlocksDB.push({ id: contentBlockID, atom: contentBlockAtom })
        })
      }
    })

    // console.log(contentsDB)
    // console.log(contentBlocksDB)
    // return contentsDB
  })

  function shareContent() {
    // check if logged in
    if (checkIsLoggedIn) {
      openShareModal()
      // analytics.track('Share Onepager Nav Button Click - Signed Up')
    } else {
      openSignUp()
      // analytics.track('Share Onepager Nav Button Click - Not Signed Up')
    }
  }

  async function saveToAccount() {
    const subdomainFromURL = window.location.host.split('.')[1]
      ? window.location.host.split('.')[0]
      : false
    // Trigger Save To Account
    const saveToAccountOnSignUp = await axios.post(
      '/api/save-to-account/save',
      {
        email: Cookies.get('wl-email'),
        collectionId: collection._id,
        templateId: findGetParameter('i'),
        template_title: onepager.title,
        template_desc: onepager.description,
        subdomain: subdomainFromURL,
      }
    )

    // check if webhook and if true hit url

    // await axios.post(
    //   '/api/save-to-account/save',
    //   {
    //     email: Cookies.get('wl-email'),
    //     collectionId: collection._id,
    //     templateId: findGetParameter('i'),
    //     template_title: onepager.title,
    //     template_desc: onepager.description,
    //     subdomain: subdomainFromURL,
    //   }
    // )

    // trigger something thats in account?
    setSavedOnepager(true)
  }

  // console.log('collection', collection)

  return (
    <div>
      <DebugObserver
        collection={collection}
        onepager={onepager}
        isOnepagerForm={isOnepagerForm}
        shouldRedirect={shouldRedirect}
        reloadSaveHistory={() => {
          reloadSaveHistory()
        }}
      />
      {/* auto save icon  */}
      <AnimatePresence>
        {isSaving && (
          <motion.div
            initial="hidden"
            animate="visible"
            exit="exit"
            transition={{ duration: 0.15 }}
            variants={{
              hidden: {
                opacity: 0,
                scale: 0.9,
              },
              visible: {
                opacity: 1,
                scale: 1,
              },
              exit: {
                opacity: 0,
                scale: 0.9,
              },
            }}
            style={{ backgroundColor: '#ffc900' }}
            className="fixed bottom-5 text-black flex flex-col items-center z-50 right-5 bg-white shadow-xl rounded-lg p-5"
          >
            <Spinner color="#FFF" size="30px" />
            <div className="mt-2 font-bold">Saving!</div>
          </motion.div>
        )}
      </AnimatePresence>

      <div
        className={Classnames(
          'bgOPNav  h-19 bg-white px-3 md:px-0 py-3 sticky shadow-lg top-0 z-40',
          {
            hidden: onepager?.hide_collection_banner,
            'flex items-center': onepager?.hide_sharebutton,
          }
        )}
        style={{
          backgroundColor: collection.banner_bg_color
            ? collection.banner_bg_color
            : '#FFF',
          color: collection.banner_text_color
            ? collection.banner_text_color
            : 'black',
          zIndex: 9999999,
          height: '69px',
        }}
      >
        <div
          className={Classnames(
            'lg:flex items-center justify-between mx-auto',
            {
              'container max-w-7xl': !isWizardLayout,
              'w-full px-6': isWizardLayout,
            }
          )}
        >
          <div
            className={Classnames('flex items-center', {
              'w-full': onepager?.onepager_type == 'static',
            })}
          >
            {/* <div className="flex-shrink-0 mr-4">
            <RiMenuFill
              onClick={() => {
                openSideBar()
              }}
              className="text-2xl cursor-pointer"
            />
          </div> */}

            <div
              // onClick={() => {
              //   openSideBar()
              // }}
              className={Classnames(
                'flex-row flex-grow justify-center h-full pt-1 md:pt-0 pb-2 md:pb-0 md:flex-row flex items-center'
              )}
            >
              {collection.logo && (
                <img
                  className="h-7 w-auto md:mb-0  mr-3 "
                  src={collection.logo}
                />
              )}
              {collection.brand && (
                <h2 className="text-base md:text-lg leading-tight md:leading-base font-bold flex items-center">
                  {collection.brand}
                </h2>
              )}
              {!collection.brand && !collection.logo && (
                <h2 className="text-base md:text-lg leading-tight md:leading-base font-bold flex items-center">
                  {collection.title}
                </h2>
              )}
            </div>

            <div
              onClick={() => {
                shareContent()
              }}
              className="flex-shrink-0 md:hidden"
            >
              <RiShareFill className="text-2xl cursor-pointer" />
            </div>
          </div>

          <div
            className={Classnames(
              'mt-3 hidden space-x-4 md:mt-0 md:flex items-center'
            )}
          >
            {isSharedContent && (
              <div className="flex items-center">
                <div className="flex-grow bg-blue-100 text-blue-700  justify-center md:flex-grow-0 flex items-center py-2 px-4  font-bold rounded ">
                  <RiEyeLine className="mr-2 text-lg" /> Viewing Shared Content
                </div>
              </div>
            )}

            {isSharedContent && !checkIsLoggedIn && (
              <div
                onClick={() => {
                  openSignUp()
                }}
                className="flex-grow bg-yellow-300 ml-3 justify-center md:flex-grow-0 hover:bg-black hover:text-white  border-2 border-black flex items-center py-2 px-4  font-bold rounded cursor-pointer"
              >
                <RiAddLine className="mr-2 text-lg" /> Create Your Own version
              </div>
            )}

            {checkIsLoggedIn && onepager?.onepager_type != 'static' && (
              <div
                className={Classnames(
                  '  rounded  text-right text-xs py-1.5 px-3 font-medium',
                  {
                    'bg-black bg-opacity-75 text-white':
                      collection.banner_text_color == 'white',
                    'bg-white bg-opacity-75 text-black':
                      collection.banner_text_color !== 'white',
                    '-mr-6': onepager?.hide_sharebutton,
                  }
                )}
              >
                <div className="text-xs opacity-70">Signed in as</div>
                <div className="font-bold">{getUserEmail}</div>
              </div>
            )}

            <div
              className={Classnames('flex items-center space-x-3', {
                hidden: onepager?.onepager_type == 'static',
              })}
            >
              {!onepager?.hide_sharebutton && (
                <div>
                  {!isSharedContent && (
                    <div
                      onClick={() => {
                        shareContent()
                      }}
                      className="hidden bg-white text-black md:flex flex-grow justify-center md:flex-grow-0 hover:bg-black hover:text-white  border-2 border-black  items-center py-2  px-4 font-bold rounded cursor-pointer"
                    >
                      <RiShareFill />
                      {checkIsLoggedIn && <div className="ml-2">Share</div>}
                      {!checkIsLoggedIn && (
                        <div className="ml-2">Save &amp; Share</div>
                      )}
                    </div>
                  )}
                </div>
              )}

              {checkIsLoggedIn && !isSavedOnepager && (
                <div
                  onClick={() => {
                    saveToAccount()
                  }}
                  id="saveToOnePagerAccount"
                  className="flex-grow bg-white text-black  justify-center md:flex-grow-0 hover:bg-black hover:text-white  border-2 border-black flex items-center py-2 px-4 ml-3 font-bold rounded cursor-pointer"
                >
                  <RiAddLine className="mr-2 text-lg" />
                  Save To My Account
                </div>
              )}
            </div>

            {isOnepagerForm && !hasSubmittedForm && (
              <div
                onClick={() => {
                  openSignUp()
                }}
                className="hidden  md:flex flex-grow bg-yellow-300  justify-center md:flex-grow-0 hover:bg-black hover:text-white  border-2 border-black  items-center py-2 px-4  font-bold rounded cursor-pointer"
              >
                <RiDownloadLine className="mr-2 text-lg" />
                <div>SUBMIT & SAVE</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default PublicNav
